export default {
    // 律师
    0: [
        {
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/home.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/home-active.png',
            name: '我的首页',
            routerName: 'lawinfo'
        },
        {
            notShow: 1,
            routerName: 'lawMessageInfo'
        },
        {
            name: '案源广场',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/case.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/case-active.png',
            list: [
                {
                    avatar: '',
                    name: '即时线索',
                    routerName: 'lawclues',
                    badgeText: '加量'
                },
                {
                    avatar: '',
                    introduction: '',
                    name: '公开咨询',
                    routerName: 'offlineQa'
                },
                {
                    avatar: '',
                    name: '1V1咨询',
                    routerName: 'consult'
                }
            ],
            isFold: false
        },
        {
            name: '内容营销',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/content.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/content-active.png',
            list: [
                {
                    name: '百度法典',
                    routerName: 'lawcodex',
                    badgeText: new Date() < new Date('2026-08-18') ? 'NEW' : ''
                },
                {
                    avatar: '',
                    name: '热搜问答',
                    routerName: 'hotQuestion',
                    badgeText: 'AI抢答'
                },
                {
                    avatar: '',
                    name: '百家号内容创作',
                    routerName: 'bjhEdit'
                },
                {
                    avatar: '',
                    name: '百家号内容管理',
                    routerName: 'bjhContent'
                },
                {
                    avatar: '',
                    name: '案例管理',
                    routerName: 'caseManage'
                },
                {
                    avatar: '',
                    name: '数字人直播',
                    routerName: 'aiLiveStream',
                    badgeText: '热门'
                }
            ],
            isFold: false
        },
        {
            name: '智能工具',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/tool.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/tool-active.png',
            list: [
                {
                    avatar: '',
                    name: 'AI合同助手',
                    routerName: 'AIContract'
                },
                {
                    avatar: '',
                    name: '法规检索',
                    routerName: 'ruleTool'
                },
                {
                    avatar: '',
                    name: '案例检索',
                    routerName: 'caseTool'
                },
                {
                    avatar: '',
                    name: 'AI诉保助手',
                    routerName: 'insuranceTool'
                }
            ],
            isFold: false
        },
        {
            name: '成长中心',
            avatar: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/business-center/business-center-icon.png',
            activeAvatar: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/business-center/bussiness-center-active-icon.png',
            list: [
                {
                    'name': '经营中心',
                    'routerName': 'businessCenter'
                },
                {
                    name: '课程中心',
                    routerName: 'courseCenter',
                    avatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/course.png',
                    activeAvatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/course-active.png'
                },
                {
                    avatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/data.png',
                    activeAvatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/data-active.png',
                    routerName: 'dataCenter',
                    name: '数据中心'
                },
                {
                    name: '会员中心',
                    avatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/vip.png',
                    activeAvatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/vip-active.png',
                    routerName: 'lawservice'
                },
                {
                    avatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/earn.png',
                    activeAvatar: 'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/earn-active.png',
                    name: '收益中心',
                    routerName: 'profitCenter'
                }
            ],
            isFold: false
        },
        {
            name: '管理中心',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/manage.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/manage-active.png',
            list: [
                {
                    avatar: '',
                    name: '智能体',
                    routerName: 'roleSet'
                },
                {
                    avatar: '',
                    name: '知识库',
                    routerName: 'repositoryManage'
                },
                {
                    avatar: '',
                    name: '咨询设置',
                    routerName: 'consultSetting',
                    badgeText: new Date() < new Date('2025-09-20') ? 'NEW' : ''
                },
                {
                    avatar: '',
                    name: '我的认证',
                    routerName: 'material'
                },
                {
                    avatar: '',
                    name: '个人信息',
                    routerName: 'personalInfo'
                },
                {
                    avatar: '',
                    name: '百家号账号',
                    routerName: 'bjhRegister'
                },
                {
                    avatar: '',
                    name: '我的百科',
                    routerName: 'myBk'
                }
            ],
            isFold: false
        }
    ],
    // 代理商
    1: [
        {
            avatar: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/home-icon.png',
            name: '我的首页',
            routerName: 'lawTpInfo'
        },
        {
            notShow: 1,
            routerName: 'lawMessageInfo'
        },
        {
            name: '会员中心',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-10/1667215029406/%E4%BC%9A%E5%91%98%403x.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-10-31T11%3A17%3A09Z%2F1800%2Fhost%2Fd3a4f8affd8a9e5420c54c5ed70f88c1ec8a179eef0fce73ea1eb12005c6420',
            list: [
                {
                    avatar: '',
                    name: '商品购买',
                    routerName: 'goodsPurchase'
                },
                {
                    avatar: '',
                    name: '订单管理',
                    routerName: 'clueOrderManage'
                },
                {
                    'avatar': '',
                    'name': '业绩看板',
                    'routerName': 'performanceDashboard'
                },
                {
                    avatar: '',
                    name: '会员码管理',
                    routerName: 'memberCodeManage'
                },
                {
                    avatar: '',
                    name: '充值交易记录',
                    routerName: 'lawChargeList'
                }
            ],
            isFold: false
        },
        {
            name: '客户中心',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-11/1667273929654/%E5%AE%A2%E6%88%B7%403x.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-11-01T03%3A38%3A49Z%2F1800%2Fhost%2F3c1f48d1821ad7ea39b99034bc2a9e9f26f84390b91702f7bc2d9efc56a3f6d',
            list: [
                {
                    avatar: '',
                    name: '客户管理',
                    routerName: 'customerList'
                },
                {
                    avatar: '',
                    name: '档期指引',
                    routerName: 'schedulGuide'
                },
                {
                    avatar: '',
                    name: '客户公海',
                    routerName: 'customerSea'
                },
                {
                    avatar: '',
                    name: '客户机会',
                    routerName: 'clientChanceList'
                },
                {
                    avatar: '',
                    name: '潜客管理',
                    routerName: 'potentialCustomerList'
                }
            ],
            isFold: false
        },
        {
            avatar:
        'https://lvlin-base.cdn.bcebos.com/fe-saas/common/member-mange-icon.png',
            name: '成员管理',
            routerName: 'agentMemberManage'
        },
        {
            avatar:
        'https://lvlin-fe-saas.bj.bcebos.com/assets/lead-management-icon.png',
            name: '1v1咨询', // 华律
            routerName: 'platformConsult1v1'
        },
        {
            avatar:
        'https://lvlin-fe-saas.bj.bcebos.com/assets/membership-management-icon.png',
            name: '成员管理', // 华律
            routerName: 'platformLawyer'
        }
    ],
    // 代理商-子账号菜单
    3: [
        {
            avatar: 'https://lvlin-base.cdn.bcebos.com/fe-saas/common/home-icon.png',
            name: '我的首页',
            routerName: 'lawTpInfo'
        },
        {
            notShow: 1,
            routerName: 'lawMessageInfo'
        },
        {
            name: '会员中心',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-10/1667215029406/%E4%BC%9A%E5%91%98%403x.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-10-31T11%3A17%3A09Z%2F1800%2Fhost%2Fd3a4f8affd8a9e5420c54c5ed70f88c1ec8a179eef0fce73ea1eb12005c6420',
            list: [
                {
                    avatar: '',
                    name: '会员码管理',
                    routerName: 'memberCodeManage'
                }
            ],
            isFold: false
        },
        {
            name: '客户中心',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-11/1667273929654/%E5%AE%A2%E6%88%B7%403x.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-11-01T03%3A38%3A49Z%2F1800%2Fhost%2F3c1f48d1821ad7ea39b99034bc2a9e9f26f84390b91702f7bc2d9efc56a3f6d',
            list: [
                {
                    avatar: '',
                    name: '客户管理',
                    routerName: 'customerList'
                },
                {
                    avatar: '',
                    name: '档期指引',
                    routerName: 'schedulGuide'
                },
                {
                    avatar: '',
                    name: '客户公海',
                    routerName: 'customerSea'
                },
                {
                    avatar: '',
                    name: '客户机会',
                    routerName: 'clientChanceList'
                },
                {
                    avatar: '',
                    name: '潜客管理',
                    routerName: 'potentialCustomerList'
                }
            ],
            isFold: false
        }
    ],
    // 律所
    2: [
        {
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/home.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/home-active.png',
            name: '我的首页',
            routerName: 'firmHome'
        },
        {
            notShow: 1,
            routerName: 'lawMessageInfo'
        },
        {
            name: '案源广场',
            avatar:
                'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/case.png',
            activeAvatar:
                'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/case-active.png',
            list: [
                {
                    avatar: '',
                    name: '即时线索',
                    routerName: 'lawclues',
                    badgeText: '加量'
                },
                {
                    avatar: '',
                    introduction: '',
                    name: '公开咨询',
                    routerName: 'offlineQa'
                }
            ],
            isFold: false
        },
        {
            name: '内容中心',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/content.png',
            list: [
                {
                    avatar: '',
                    name: '内容营销',
                    routerName: 'contentMarketing'
                }
            ],
            isFold: false
        },
        {
            name: '课程中心',
            routerName: 'courseCenter',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/course.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/course-active.png'
        },
        {
            name: '工具服务',
            avatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/tool.png',
            activeAvatar:
        'https://lvlin-base.bj.bcebos.com/fe-saas/component/sidebar/tool-active.png',
            list: [
                {
                    avatar: '',
                    name: 'AI合同助手',
                    routerName: 'AIContract'
                }
            ],
            isFold: false
        },
        {
            name: '管理中心',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-10/1667215079229/%E7%AE%A1%E7%90%86%403x.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-10-31T11%3A17%3A59Z%2F1800%2Fhost%2Fccb425c12dfd2c15ab33e42417e5401af831af26b14ec2876856cb698c8ceba',
            list: [
                {
                    avatar: '',
                    name: '律所简介',
                    routerName: 'firmintro'
                },
                {
                    avatar: '',
                    name: '成员管理',
                    routerName: 'memberManage'
                },
                {
                    avatar: '',
                    name: '团队律师',
                    routerName: 'teamLawyer'
                },
                {
                    avatar: '',
                    name: '案例管理',
                    routerName: 'firmCaseManage'
                },
                {
                    avatar: '',
                    name: '律所认证',
                    routerName: 'lawFirmAuthentication'
                }
            ],
            isFold: false
        },
        {
            name: '律所服务',
            avatar:
        'https://bj.bcebos.com/v1/midpf-mp-pub/2022-9/1663823774538/5dcadf8b694ef88a1e912a88b.png?authorization=bce-auth-v1%2Fb6e75800f26d4a508f75f30902007a52%2F2022-09-22T05%3A16%3A14Z%2F1800%2Fhost%2F545295dd29b98d431755bb349e9a6fd735fca3a99d44ae4d4dcfec3730d2fa',
            list: [
                {
                    avatar: '',
                    name: '会员中心',
                    routerName: 'firmIndex'
                },
                {
                    avatar: '',
                    name: '权益授权管理',
                    routerName: 'vipSet'
                }
            ],
            isFold: false
        },
        {
            avatar:
        'https://lvlin-fe-saas.bj.bcebos.com/assets/lead-management-icon.png',
            name: '1v1咨询', // 华律
            routerName: 'platformConsult1v1'
        },
        {
            avatar:
        'https://lvlin-fe-saas.bj.bcebos.com/assets/membership-management-icon.png',
            name: '成员管理', // 华律
            routerName: 'platformLawyer'
        }
    ],
    // uc登录用户
    uc: [
        {
            avatar:
        'https://lvlin-base.cdn.bcebos.com/fe-saas/page/bill-manage/bill-manage-icon.png',
            name: '账单管理',
            routerName: 'clueBillManage'
        }
    ]
};
